import { memo, useCallback } from 'react';
import { Trans } from '@bonanza-social/i18n';
import {
  BottomSheet,
  StackNavigationProp,
  useNavigation,
} from '@bonanza-social/navigation';
import { Box, Button, Icon, ScrollView, Text } from '@bonanza-social/moonlight';
import { UploadDocumentsNavigatorParamsList } from '../../navigators/UploadDocumentsNavigator.types';
import {
  UPLOAD_DOCUMENTS_INFO_SECTIONS,
  CONTENT_CONTAINER_STYLE,
} from './UploadDocumentsInfo.content';

const components = {
  acceptableDocuments: (
    <Text // TODO: make it gradient when the alignment fix is pushed into main branch
      variant="link-medium"
      onPress={() => {
        BottomSheet.open({
          namespace: 'onboarding',
          type: 'AcceptableDocuments',
          titleKey: 'acceptableDocumentsTitle',
          titleNS: 'onboarding',
          scrollable: true,
        });
      }}
    />
  ),
};

function UploadDocumentsInfo() {
  const navigation =
    useNavigation<StackNavigationProp<UploadDocumentsNavigatorParamsList>>();

  const onButtonPress = useCallback(() => {
    navigation.navigate('UploadDocuments');
  }, [navigation]);

  return (
    <>
      <ScrollView contentContainerStyle={CONTENT_CONTAINER_STYLE}>
        <Text
          variant="h5"
          locKey="uploadDocumentsInfoTitle"
          locNS="onboarding"
          color="darkSurfacePrimary"
        />
        <Text
          variant="h5"
          locKey="uploadDocumentsInfoDescription"
          locNS="onboarding"
          color="darkSurfacePrimary"
        />
        {UPLOAD_DOCUMENTS_INFO_SECTIONS.map((section) => (
          <Box
            key={section}
            backgroundColor="primaryBackground"
            borderRadius="radius-200"
            padding="space-200"
            gap="space-200"
          >
            <Box flexDirection="row" gap="space-100" alignItems="center">
              <Icon
                name="article"
                gradient="accentBackground"
                width="space-600"
                height="space-600"
              />
              <Text
                variant="body-s-semi"
                locKey={`uploadDocumentsInfoSection${section}Title`}
                locNS="onboarding"
                color="darkSurfacePrimary"
              />
            </Box>
            <Text
              variant="body-s"
              locKey={`uploadDocumentsInfoSection${section}Subtitle`}
              locNS="onboarding"
              color="darkSurfacePrimary"
            />
            {section === 'Id' && (
              <Text
                variant="caption"
                locKey={`uploadDocumentsInfoSection${section}Caption`}
                locNS="onboarding"
                color="darkSurfacePrimary"
              />
            )}
          </Box>
        ))}
        <Text variant="body-m" color="darkSurfacePrimary">
          <Trans
            i18nKey="uploadDocumentsInfoHelp"
            ns="onboarding"
            components={components}
          />
        </Text>
      </ScrollView>
      <Button
        locKey="submitFiles"
        locNS="onboarding"
        size="large"
        marginHorizontal="space-600"
        onPress={onButtonPress}
      />
    </>
  );
}

export default memo(UploadDocumentsInfo);
